import { Link } from "react-router-dom";
import Header from "../../components/layout/Header/Header";
import Footer from "../../components/layout/Footer/Footer";
import Container from "../../components/layout/Container/Container";
import { useBlogPosts } from "../../api/queries/useBlogPosts";
import { useGallery } from "../../api/queries/useGallery";
import s from "./BlogPage.module.scss";

function resolveImageUrl(path?: string) {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  if (path.startsWith("/")) return path;
  return `/${path}`;
}

export default function BlogPage() {
  const { data, isLoading, isError } = useBlogPosts();
  const { data: gallery } = useGallery();

  const galleryMap = new Map<number, string>();
  (gallery ?? []).forEach((g) => galleryMap.set(g.id, g.image_path));

  const posts = (data ?? []).filter((p) => p.is_published);

  return (
    <div className={s.pageWrap}>
      <Header />

      {/* main растягивается, чтобы футер прижимался к низу */}
      <main className={`${s.page} ${s.main}`}>
        <section className={`section section--tight ${s.hero}`}>
          <Container className={s.container}>
            <h1 className={s.title}>Акции</h1>
        
          </Container>
        </section>

        <section className="section section--tight">
          <Container className={s.container}>
            {isLoading && <div className={s.state}>Загружаем…</div>}
            {isError && <div className={s.state}>Не удалось загрузить блог</div>}

            {!isLoading && !isError && posts.length === 0 && (
              <div className={s.state}>Пока нет опубликованных материалов.</div>
            )}

            <div className={s.grid}>
              {posts.map((p) => {
                const rawPath = p.preview_image_id
                  ? galleryMap.get(p.preview_image_id)
                  : "";
                const imgSrc = resolveImageUrl(rawPath);

                return (
                  <Link key={p.id} to={`/blog/${p.id}`} className={s.card}>
                    <div className={s.thumb}>
                      {imgSrc ? (
                        <img
                          src={imgSrc}
                          alt={p.title}
                          loading="lazy"
                          className={s.img}
                          onError={(e) => {
                            // если бек пока не отдаёт статику — просто скрываем картинку
                            (e.currentTarget as HTMLImageElement).style.display =
                              "none";
                          }}
                        />
                      ) : (
                        <div className={s.thumbPlaceholder} />
                      )}
                    </div>

                    <div className={s.body}>
                      {p.published_at && (
                        <div className={s.meta}>
                          {new Date(p.published_at).toLocaleDateString("ru-RU")}
                        </div>
                      )}

                      <div className={s.cardTitle}>{p.title}</div>
                      <div className={s.cardText}>{p.preview_text}</div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </Container>
        </section>
      </main>

      <Footer />
    </div>
  );
}
